import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Sessions from './pages/Sessions';
import HealingRequests from './pages/HealingRequests';
import CourseCompletions from './pages/CourseCompletions';
import Users from './pages/Users';
import StudentDashboard from './pages/StudentDashboard';
import PatientDashboard from './pages/PatientDashboard';
import HealerDashboard from './pages/HealerDashboard';
import GeneralDashboard from './pages/GeneralDashboard';
import WPCallback from './pages/WPCallback';
import Announcements from './pages/Announcements';
import Finance from './pages/Finance';
import Impersonate from './pages/Impersonate';
import PractitionerActivities from './pages/PractitionerActivities';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/wp-callback" element={<WPCallback />} />
          <Route path="/dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/sessions" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Sessions />
            </ProtectedRoute>
          } />
          <Route path="/healing-requests" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <HealingRequests />
            </ProtectedRoute>
          } />
          <Route path="/course-completions" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CourseCompletions />
            </ProtectedRoute>
          } />
          <Route path="/practitioner-activities" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <PractitionerActivities />
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Users />
            </ProtectedRoute>
          } />
          <Route path="/finance" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Finance />
            </ProtectedRoute>
          } />
          <Route path="/announcements" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Announcements />
            </ProtectedRoute>
          } />
          <Route path="/student" element={
            <ProtectedRoute allowedRoles={['student', 'admin']}>
              <StudentDashboard />
            </ProtectedRoute>
          } />
          <Route path="/patient" element={
            <ProtectedRoute allowedRoles={['patient', 'admin']}>
              <PatientDashboard />
            </ProtectedRoute>
          } />
          <Route path="/healer" element={
            <ProtectedRoute allowedRoles={['healer', 'admin']}>
              <HealerDashboard />
            </ProtectedRoute>
          } />
          <Route path="/general" element={
            <ProtectedRoute allowedRoles={['general', 'admin']}>
              <GeneralDashboard />
            </ProtectedRoute>
          } />
          <Route path="/impersonate" element={<Impersonate />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;